(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    class AnnouncementBar {
      constructor(root) {
        this.root = root;
        this.id = root.dataset.sectionId;

        this.cfg = {
          autoplay:    root.dataset.autoplay === 'true',
          interval:    parseInt(root.dataset.interval, 10) || 5000,
          loop:        root.dataset.loop !== 'false',
          random:      root.dataset.random === 'true',
          pauseHover:  root.dataset.pauseHover !== 'false',
          pauseHidden: root.dataset.pauseHidden !== 'false',
          swipe:       root.dataset.swipe !== 'false',
          keyboard:    root.dataset.keyboard === 'true',
          onceSession: root.dataset.onceSession === 'true',
          closable:    root.dataset.closable === 'true',
          closeDays:   parseInt(root.dataset.closeDays, 10) || 0
        };

        if (this.cfg.closable && this.isClosed()) { return; }
        if (this.cfg.onceSession && this.seenThisSession()) { return; }

        this.slidesWrap = root.querySelector('[data-ab-slides]');
        this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-ab-slide]'));
        this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-ab-dot]'));
        this.prevBtn = root.querySelector('[data-ab-prev]');
        this.nextBtn = root.querySelector('[data-ab-next]');
        this.closeBtn = root.querySelector('[data-ab-close]');

        if (!this.slides.length) { return; }

        this.order = this.slides.map((_, i) => i);
        if (this.cfg.random) { this.shuffle(this.order); }

        this.current = 0;
        this.timer = null;
        this.isPaused = false;

        this.init();
      }

      init() {
        this.root.removeAttribute('hidden');
        this.activate(0);
        this.bindEvents();
        if (this.cfg.autoplay && this.slides.length > 1) { this.play(); }
        if (this.cfg.onceSession) { this.markSeen(); }
      }

      activate(step) {
        const realIdx = this.order[step];
        this.slides.forEach((slide, i) => {
          const isActive = i === realIdx;
          slide.classList.toggle('is-active', isActive);
          slide.classList.remove('is-leaving');
          if (isActive) { slide.removeAttribute('aria-hidden'); }
          else { slide.setAttribute('aria-hidden', 'true'); }
        });
        this.dots.forEach((dot, i) => {
          const active = i === step;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.current = step;
      }

      go(step) {
        const total = this.slides.length;
        if (total <= 1) { return; }
        if (step < 0) { step = this.cfg.loop ? total - 1 : 0; }
        if (step >= total) { step = this.cfg.loop ? 0 : total - 1; }
        if (step === this.current) { return; }
        const leaving = this.slides[this.order[this.current]];
        if (leaving) { leaving.classList.add('is-leaving'); }
        this.activate(step);
      }

      next() { this.go(this.current + 1); }
      prev() { this.go(this.current - 1); }

      play() {
        this.stop();
        if (!this.cfg.autoplay || this.slides.length <= 1) { return; }
        this.timer = window.setInterval(() => { if (!this.isPaused) { this.next(); } }, this.cfg.interval);
      }
      stop() { if (this.timer) { window.clearInterval(this.timer); this.timer = null; } }
      restart() { if (this.cfg.autoplay) { this.play(); } }

      bindEvents() {
        if (this.nextBtn) { this.nextBtn.addEventListener('click', () => { this.next(); this.restart(); }); }
        if (this.prevBtn) { this.prevBtn.addEventListener('click', () => { this.prev(); this.restart(); }); }

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => { this.go(parseInt(dot.dataset.index, 10)); this.restart(); });
        });

        if (this.closeBtn) { this.closeBtn.addEventListener('click', () => this.close()); }

        // Hover pauzeert (geen kleurverandering)
        if (this.cfg.pauseHover) {
          this.root.addEventListener('mouseenter', () => { this.isPaused = true; });
          this.root.addEventListener('mouseleave', () => { this.isPaused = false; });
          this.root.addEventListener('focusin', () => { this.isPaused = true; });
          this.root.addEventListener('focusout', () => { this.isPaused = false; });
        }

        if (this.cfg.pauseHidden) {
          document.addEventListener('visibilitychange', () => { this.isPaused = document.hidden; });
        }

        if (this.cfg.keyboard) {
          this.root.setAttribute('tabindex', '0');
          this.root.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight') { e.preventDefault(); this.next(); this.restart(); }
            if (e.key === 'ArrowLeft')  { e.preventDefault(); this.prev(); this.restart(); }
          });
        }

        if (this.cfg.swipe) { this.bindSwipe(); }
      }

      bindSwipe() {
        let startX = 0, startY = 0, tracking = false;
        const threshold = 40;
        this.slidesWrap.addEventListener('touchstart', (e) => {
          const t = e.changedTouches[0];
          startX = t.clientX; startY = t.clientY; tracking = true;
        }, { passive: true });
        this.slidesWrap.addEventListener('touchend', (e) => {
          if (!tracking) { return; }
          tracking = false;
          const t = e.changedTouches[0];
          const dx = t.clientX - startX;
          const dy = t.clientY - startY;
          if (Math.abs(dx) > threshold && Math.abs(dx) > Math.abs(dy)) {
            if (dx < 0) { this.next(); } else { this.prev(); }
            this.restart();
          }
        }, { passive: true });
      }

      close() {
        this.stop();
        const h = this.root.offsetHeight;
        this.root.style.height = h + 'px';
        void this.root.offsetHeight;
        this.root.classList.add('ab-closing');
        this.root.style.height = '0px';
        this.rememberClosed();
        const remove = () => { this.root.setAttribute('hidden', ''); this.root.removeEventListener('transitionend', remove); };
        this.root.addEventListener('transitionend', remove);
        window.setTimeout(remove, 400);
      }

      storageKey() { return 'ab-closed:' + this.id; }
      rememberClosed() {
        try {
          const days = this.cfg.closeDays;
          const value = days > 0 ? String(Date.now() + days * 86400000) : 'forever';
          window.localStorage.setItem(this.storageKey(), value);
        } catch (e) {}
      }
      isClosed() {
        try {
          const v = window.localStorage.getItem(this.storageKey());
          if (!v) { return false; }
          if (v === 'forever') { return true; }
          if (Date.now() > parseInt(v, 10)) { window.localStorage.removeItem(this.storageKey()); return false; }
          return true;
        } catch (e) { return false; }
      }

      seenThisSession() {
        try { return window.sessionStorage.getItem('ab-seen:' + this.id) === '1'; } catch (e) { return false; }
      }
      markSeen() {
        try { window.sessionStorage.setItem('ab-seen:' + this.id, '1'); } catch (e) {}
      }

      shuffle(arr) {
        for (let i = arr.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [arr[i], arr[j]] = [arr[j], arr[i]];
        }
      }

      destroy() { this.stop(); }

      static initStickyHide(root) {
        if (root.dataset.sticky !== 'hide-on-scroll') { return; }
        let lastY = window.pageYOffset;
        let ticking = false;
        const onScroll = () => {
          const y = window.pageYOffset;
          if (Math.abs(y - lastY) > 5) {
            root.classList.toggle('ab-hidden', y > lastY && y > root.offsetHeight);
            lastY = y;
          }
          ticking = false;
        };
        window.addEventListener('scroll', () => {
          if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; }
        }, { passive: true });
      }
    }

    const instances = {};

    function initBar(root) {
      if (!root || instances[root.dataset.sectionId]) { return; }
      instances[root.dataset.sectionId] = new AnnouncementBar(root);
      AnnouncementBar.initStickyHide(root);
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-announcement-bar]').forEach(initBar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (e) => {
      const root = e.target.querySelector('[data-announcement-bar]');
      if (root) { delete instances[root.dataset.sectionId]; initBar(root); }
    });
    document.addEventListener('shopify:section:unload', (e) => {
      const root = e.target.querySelector('[data-announcement-bar]');
      if (root && instances[root.dataset.sectionId]) {
        instances[root.dataset.sectionId].destroy();
        delete instances[root.dataset.sectionId];
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-banner"] && !Shopify.designMode) return;
  try {
    
  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      
    }
  connectedCallback() {
    const sectionId = this.getAttribute('section-id');
    const image = this.querySelector('img');
    const aosAnimation = this.getAttribute('data-aos');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this.parallaxEffect);
        } else {
          window.removeEventListener('scroll', this.parallaxEffect);
        }
      });
    });

    const section = document.getElementById(sectionId);
    observer.observe(section);

    const imageContainer = this;
    imageContainer.style.transform = 'translateY(0)';

    this.parallaxEffect = () => {
      const scrollPosition = window.pageYOffset;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const parallaxValue = (scrollPosition / maxScroll) * 50;
      image.style.transform = `translateY(-${parallaxValue}%) scale(1.2)`;
    };

  }
}

customElements.define('parallax-image', ParallaxImage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
  class productPairs extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url).
      then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error! Status: ".concat(response.status));
        }
        return response.text();
      }).
      then((response) => {
        var frag = document.createDocumentFragment(),
          fetchedContent = document.createElement('div');
        frag.appendChild(fetchedContent);
        fetchedContent.innerHTML = response;

        var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
        if (replacementContent) {
          this.innerHTML = replacementContent.innerHTML;
        }
      });
    }
  }

  customElements.define('product-pairs', productPairs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
 
class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
              const swiperContainer = this.querySelector('.swiper-container');
              const getID = swiperContainer.getAttribute("data-id");
              const swiperID = this.querySelector(`.swipercol-${getID}`);
              const spaceBetween = parseInt(swiperContainer.getAttribute('data-space-between'), 10);
              const perviewDesktop = swiperContainer.getAttribute('data-perview-desktop');
              if (swiperContainer) {
                new Swiper(swiperContainer, {
                  slidesPerView: "auto",
                  freeMode: false,
                  autoHeight: true,
                  calculateHeight:true,
                  freeModeSticky: true,
                  centeredSlides: false,
                  grabCursor: true,
                  watchSlidesVisibility: true,
                  watchSlidesProgress: true,
                  preloadImages: true,
                  updateOnImagesReady: true,
                  spaceBetween: spaceBetween,
                  observer: true,
                  observeParents: true,
                  parallax:true,
                  a11y: true,
                  keyboard: {
                    enabled: true,
                  },
                  breakpoints: {
                    320: {
                      slidesPerView: 2,
                      spaceBetween: 20
                    },
                    576: {
                      slidesPerView: 2,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    992: {
                      slidesPerView: perviewDesktop,
                    }
                  },
                  scrollbar: {
                    el: this.querySelector(".swiper-scrollbar"),
                  },
                  navigation: {
                    nextEl: this.querySelector(".swiper-button-next"),
                    prevEl: this.querySelector(".swiper-button-prev"),
                  },
                });
              } else {
                console.error('No element with class "swiper-container" found.');
              }
            }
            jdgm.customizeBadges();
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
class productPairsRight extends HTMLElement {
  connectedCallback() {
    fetch(this.dataset.url).
    then((response) => {
      if (!response.ok) {
        throw new Error("HTTP error! Status: ".concat(response.status));
      }
      return response.text();
    }).
    then((response) => {
      var frag = document.createDocumentFragment(),
        fetchedContent = document.createElement('div');
      frag.appendChild(fetchedContent);
      fetchedContent.innerHTML = response;

      var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
      if (replacementContent) {
        this.innerHTML = replacementContent.innerHTML;
      }
    });
  }
}

customElements.define('product-pairsright', productPairsRight);

class BuyNow extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  connectedCallback() {
    this.checkAgreement();
  }

  handleClick(event) {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    const checkoutButton = this.querySelector('.product-form__buynow');
    
    if (event.target === agreeCheckbox || event.target === this.querySelector('.checkbox__label')) {
      if (agreeCheckbox.checked) {
        checkoutButton.classList.remove('disabled');
      } else {
        checkoutButton.classList.add('disabled');
      }
    }
  }
  checkAgreement() {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    return agreeCheckbox.checked;
  }
}

customElements.define('buy-now', BuyNow);

var initPhotoSwipeFromDOM = function(gallerySelector) {

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i]; // <figure> element
    // include only element nodes 
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    
    

    // create slide object
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };



    if (figureEl.children.length > 1) {
      // <figcaption> content
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      // thumbnail element, retrieving thumbnail url
      item.msrc = linkEl.children[0].getAttribute('data-phototview');
    }

    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }

  return items;
};

// find nearest parent element
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

// triggers when user clicks on thumbnail
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  // find root element of slide
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  // find index of clicked item by looping through all child nodes
  // alternatively, you may define index via data- attribute
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }



  if (index >= 0) {
    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  // define options (if needed)
  options = {
    maxSpreadZoom: 1, 
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,

    // define gallery index (for URL)
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

  };

  // PhotoSwipe opened from URL
  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used 
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  // exit if index not found
  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  // Pass data to PhotoSwipe and initialize it
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};

// loop through all gallery elements and bind events
var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("or-timeline__img--bounce-in"),t.contents[e].classList.add("or-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-or-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();
})();
